export enum PaymentActivityType {
  Regular = 0,
  Free = 1,
  Extended = 2
}
